import './utils/globalErrors';

import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css"
import App from './App';
import "./bootstrap/realtime";
import "./bootstrap/favicon";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);


